// Common Skills Database - ~200 most popular skills across industries
export const COMMON_SKILLS = [
  // Technical/Programming
  'JavaScript', 'Python', 'Java', 'C++', 'C#', 'PHP', 'Ruby', 'Go', 'Swift', 'Kotlin',
  'TypeScript', 'HTML', 'CSS', 'SQL', 'NoSQL', 'MongoDB', 'PostgreSQL', 'MySQL',
  'React', 'Angular', 'Vue.js', 'Node.js', 'Express.js', 'Django', 'Flask', 'Spring',
  'REST API', 'GraphQL', 'Microservices', 'Docker', 'Kubernetes', 'AWS', 'Azure', 'GCP',
  'Git', 'GitHub', 'GitLab', 'CI/CD', 'Jenkins', 'Agile', 'Scrum', 'DevOps',
  
  // Data & Analytics
  'Data Analysis', 'Data Science', 'Machine Learning', 'Deep Learning', 'AI', 'TensorFlow',
  'PyTorch', 'Pandas', 'NumPy', 'R', 'Tableau', 'Power BI', 'Excel', 'SQL Server',
  'Business Intelligence', 'Data Visualization', 'Statistics', 'Big Data', 'Hadoop',
  'Spark', 'ETL', 'Data Mining', 'Predictive Analytics',
  
  // Design & Creative
  'UI/UX Design', 'Figma', 'Adobe XD', 'Sketch', 'Photoshop', 'Illustrator', 'InDesign',
  'After Effects', 'Premiere Pro', 'Framer', 'Prototyping', 'Wireframing', 'User Research',
  'Design Systems', 'Brand Identity', 'Graphic Design', 'Web Design', 'Mobile Design',
  
  // Project Management
  'Project Management', 'PMP', 'Agile', 'Scrum', 'Kanban', 'Jira', 'Confluence', 'Trello',
  'Asana', 'Microsoft Project', 'Risk Management', 'Stakeholder Management', 'Budget Management',
  'Resource Planning', 'Change Management', 'Process Improvement', 'Lean', 'Six Sigma',
  
  // Business & Management
  'Leadership', 'Team Management', 'Strategic Planning', 'Business Development', 'Sales',
  'Marketing', 'Digital Marketing', 'SEO', 'SEM', 'Content Marketing', 'Social Media Marketing',
  'Email Marketing', 'Analytics', 'CRM', 'Salesforce', 'HubSpot', 'Customer Service',
  'Operations Management', 'Supply Chain', 'Logistics', 'Procurement', 'Vendor Management',
  
  // Finance & Accounting
  'Financial Analysis', 'Accounting', 'QuickBooks', 'SAP', 'Oracle', 'Financial Modeling',
  'Budgeting', 'Forecasting', 'Tax Preparation', 'Auditing', 'GAAP', 'IFRS', 'Excel',
  'Financial Reporting', 'Cost Analysis', 'Investment Analysis',
  
  // Communication & Writing
  'Technical Writing', 'Content Writing', 'Copywriting', 'Editing', 'Proofreading',
  'Public Speaking', 'Presentation Skills', 'Communication', 'Interpersonal Skills',
  'Negotiation', 'Conflict Resolution', 'Cross-functional Collaboration',
  
  // Industry-Specific
  'Healthcare', 'HIPAA', 'Clinical Research', 'Pharmaceutical', 'Manufacturing', 'Quality Control',
  'CAD', 'AutoCAD', 'SolidWorks', 'Engineering', 'Civil Engineering', 'Mechanical Engineering',
  'Electrical Engineering', 'Software Engineering', 'Systems Engineering',
  
  // Soft Skills
  'Problem Solving', 'Critical Thinking', 'Time Management', 'Organization', 'Adaptability',
  'Creativity', 'Innovation', 'Attention to Detail', 'Multitasking', 'Work Ethic',
  'Collaboration', 'Teamwork', 'Mentoring', 'Training', 'Coaching',
  
  // Languages
  'English', 'Spanish', 'French', 'German', 'Mandarin', 'Japanese', 'Portuguese', 'Italian',
  'Arabic', 'Hindi', 'Russian', 'Korean',
  
  // Certifications & Methodologies
  'ITIL', 'COBIT', 'TOGAF', 'PRINCE2', 'CAPM', 'CSM', 'SAFe', 'ITSM',
  'ISO 9001', 'ISO 27001', 'GDPR', 'Compliance', 'Security', 'Cybersecurity',
  
  // Cloud & Infrastructure
  'Linux', 'Windows Server', 'VMware', 'Virtualization', 'Networking', 'TCP/IP',
  'Firewall', 'VPN', 'Active Directory', 'LDAP', 'DNS', 'Load Balancing',
  
  // Testing & QA
  'QA', 'Testing', 'Selenium', 'Jest', 'JUnit', 'Test Automation', 'Manual Testing',
  'Performance Testing', 'Security Testing', 'API Testing',
  
  // Mobile Development
  'iOS Development', 'Android Development', 'React Native', 'Flutter', 'Xamarin',
  'Mobile App Design', 'App Store Optimization',
  
  // E-commerce & CMS
  'Shopify', 'WooCommerce', 'Magento', 'WordPress', 'Drupal', 'Content Management',
  'E-commerce', 'Payment Processing', 'Stripe', 'PayPal'
];

// Get skills that match a search term
export const getMatchingSkills = (searchTerm, userSkills = []) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return [];
  }
  
  const term = searchTerm.toLowerCase().trim();
  const matching = COMMON_SKILLS.filter(skill => 
    skill.toLowerCase().includes(term)
  );
  
  // Remove duplicates and skills already in user's list
  const userSkillsLower = userSkills.map(s => s.toLowerCase());
  return matching.filter(skill => !userSkillsLower.includes(skill.toLowerCase()));
};

// Get all available skills (user skills + common skills)
export const getAllAvailableSkills = (userSkills = []) => {
  const userSkillsLower = userSkills.map(s => s.toLowerCase());
  const available = COMMON_SKILLS.filter(skill => 
    !userSkillsLower.includes(skill.toLowerCase())
  );
  return [...userSkills, ...available];
};

export default COMMON_SKILLS;
